import PlaceModel from '@opsbase/lib-data-model/models/PlaceModel';
class PlaceDisplayItem extends PlaceModel {
    constructor(o) {
        super();
        super.init(o);
    }
}
export default PlaceDisplayItem;
